import { useEffect, useState } from 'react'
import { collection, onSnapshot } from 'firebase/firestore'
import { firestore } from '../firebase'
import { useAuth } from '../auth/AuthProvider'

export interface DeviceSummary {
  deviceId: string
  name: string
  platform: string
}

/**
 * Subscribes to users/{uid}/devices and returns a Map<deviceId, DeviceSummary>.
 * Used by the library card to render "Available on <Device name>" badges
 * for physical movies whose ownerDeviceIds[] reference one or more devices.
 */
export function useDevices(): Map<string, DeviceSummary> {
  const { user } = useAuth()
  const [devices, setDevices] = useState<Map<string, DeviceSummary>>(new Map())

  useEffect(() => {
    if (!user) {
      setDevices(new Map())
      return
    }
    const ref = collection(firestore, `users/${user.uid}/devices`)
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const next = new Map<string, DeviceSummary>()
        snap.forEach((doc) => {
          const data = doc.data()
          next.set(doc.id, {
            deviceId: doc.id,
            name: typeof data.name === 'string' ? data.name : 'Unknown device',
            platform: typeof data.platform === 'string' ? data.platform : '',
          })
        })
        setDevices(next)
      },
      (err) => {
        console.error('[useDevices]', err)
      }
    )
    return unsub
  }, [user])

  return devices
}
